const DevConfig = {
  navURL: "https://wt06.bluecross.com.hk",

  //接口请求的前缀
  baseURL: "api",

  //付款的js
  paymentJs:
    "https://test-gateway.mastercard.com/static/checkout/checkout.min.js",

  //  antd Upload组件的上传接口地址  注意开发环境下，需要找后端开cors
  actionTempUrl:
    "https://wt01.bluecross.com.hk/MedicalService/api/VHISLoveYourSelf/SaveF",

  // 文件打开tab预览的baseUrl
  preViewUrl: "https://wt01.bluecross.com.hk",

  superAgentURL: "https://wt01.bluecross.com.hk/SuperAgent",
};

export default DevConfig;
